import { Scope, StyleAttributor } from 'parchment';
export const PaddingStyle = new StyleAttributor('padding', 'padding', {
    scope: Scope.INLINE,
});
